import {
  all,
  call, put, select,
} from 'redux-saga/effects';
import { commonActions } from '../reducers/common';
import { actions as taggingActions } from '../reducers/tagging';
import { actions as apisNeedsActions } from '../reducers/apisNeeds';
import { getProductOfferingData } from '../bitSagas/getProductOffering';
import { getInsuranceData as getInsuranceDataBit } from '../bitSagas/getInsuranceData';
import { getTerminalData as getTerminalDataBit } from '../bitSagas/getTerminalData';
import { decreaseStock as decreaseStockBit } from '../bitSagas/decreaseStock';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';

const offerStore = state => state.offer;
const flowStore = state => state.flow;

export function* getInsuranceData(params) {
  const { showError, normalizeHttpErrors } = params;

  const { storageId, productOffering, insurancePo, insuranceModality } = yield select(offerStore);

  if (!insuranceModality || !insurancePo) {
    return null;
  }

  const args = {
    idMemory: storageId,
    idSeguroPO: insurancePo,
    insuranceType: insuranceModality,
    productOfferingId: productOffering,
    normalizeHttpErrors,
  }

  try{
    const response = yield call(getInsuranceDataBit, args);

    if (response?.options && response.options.length === 1) {
      const insuranceData = {
        prices: null,
        promotionalText: null,
      };

      const insuranceRawData = response.options[0];

      if (insuranceRawData?.prices && insuranceRawData.prices.length === 1) {
        const pricesToMap = insuranceRawData.prices[0];

        if (pricesToMap?.recurringCharges) {
          insuranceData.prices = pricesToMap.recurringCharges;
        }
      }

      if (insuranceRawData?.promotion?.texts && insuranceRawData?.promotion?.texts.length === 1) {
        insuranceData.promotionalText = insuranceRawData.promotion.texts[0].text;
      }

      yield put(apisNeedsActions.setInsuranceData(insuranceData));
    }
  } catch (e) {
    return null;
  }
}

export function* getProductOffering(params) {
  const { showError, normalizeHttpErrors } = params;
  const offerInfo = yield select(offerStore);
  const { allPOsToBuy, productOfferingAlt, productOfferingsToUpgrade, productOfferingsToDowngrade, netflixToDowngrade, netflixObj, ottProductsArray } = offerInfo;
  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: commonActions.setProductOfferingInfo,
  };
  if ((allPOsToBuy && Array.isArray(allPOsToBuy) && allPOsToBuy.length > 0) || productOfferingAlt || productOfferingsToUpgrade || productOfferingsToDowngrade || netflixToDowngrade) {
    let productOfferingsToSearch = [...allPOsToBuy];
    if(productOfferingAlt){
      productOfferingsToSearch = [...productOfferingsToSearch, productOfferingAlt];
    }
    if(productOfferingsToUpgrade){
      productOfferingsToSearch = [...productOfferingsToSearch, ...productOfferingsToUpgrade];
    }
    if(productOfferingsToDowngrade){
      productOfferingsToSearch = [...productOfferingsToSearch, ...productOfferingsToDowngrade];
    }
    if(netflixToDowngrade){
      productOfferingsToSearch = [...productOfferingsToSearch, netflixToDowngrade];
    }
    try {
      yield all(productOfferingsToSearch.map(idPO => {
        let modality;
        if(netflixObj?.productOffering===idPO){
          modality = netflixObj.mode;
        } else {
          const ottFound = ottProductsArray.find(ottProduct => ottProduct.productOffering === idPO);
          if(ottFound){
            modality = ottFound.mode;
          }
        }
        return call(getProductOfferingData, { normalizeHttpErrors, reduxUpdate, idPO, modality })
      }
    ));
    } catch (e) {
      console.log(e);
    }
  }
}

export function* getTerminal(params) {
  const { showError, normalizeHttpErrors } = params;
  const offerInfo = yield select(offerStore);
  const flowInfo = yield select(flowStore);

  const {
    colorId, storageId, productOffering, r2rType,
  } = offerInfo;
  
  const { isSelfEmployedFlow, flowName, useCatalogPrice } = flowInfo.flowJson;
  
  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: commonActions.setTerminalInfo,
  };
  try {
    const getTerminalDataParams = {
      productOffering, color: colorId, storage: storageId, r2rType, isSelfEmployedFlow, flowName, useCatalogPrice, reduxUpdate, normalizeHttpErrors
    };
    const response = yield call(getTerminalDataBit, getTerminalDataParams);
    const { name, color, storage, urlNewFicha } = response;

    yield put(apisNeedsActions.setR2RFileUrl(urlNewFicha));

    yield put(commonActions.setProductOfferingInfo({ // TODO refactor hacer este guardado de redux junto al commonActions.setTerminalInfo que se lanza un poco mas arriba?
      productOfferingName: name,
      productOfferingId: productOffering,
    }));

    if (flowInfo.flowJson.sendAliasAtSearch) {
      const alias = `${name}${storage ? ' ' + storage : ''}${color ? ' ' + color : ''}`;
      yield put(taggingActions.setAliasSellingProduct(alias));
    }

    return null;
  } catch (error) {
    const errorResponse = megaMinderStatus.KO;
    errorResponse.errorInfo = error;

    return errorResponse;
  }
}


export function decreaseStock(params, context) {
  const {
    showError, normalizeHttpErrors, productOffering, colorId, storageId,
  } = params;

  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: null,
  };

  try {
    const decreaseStockParams = {
      productOffering, colorId, storageId, reduxUpdate, normalizeHttpErrors,
    };
    decreaseStockBit(decreaseStockParams, context);
  } catch (e) {
    console.log(e);
  }
}
